import { Component, Input, ChangeDetectorRef, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Usuario } from '../../../../../interfaces/usuario/usuario.interface';
import { OptionPermissao, RequestSalvarPermissoes, PermissaoUsuario } from '../../../../../interfaces/usuario/permissao.interface';
import { PermissaoService } from '../../../../../services/permissao.service';
import { AuthService } from '../../../../../services/auth.service';
import { EnumPermissao } from '../../../../../enums/permissoes.enum';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../../../../services/usuario.service';
import { SaldoService } from '../../../../../services/saldo.service';
@Component({
  selector: 'app-modal-gestao-acessos',
  templateUrl: './modal-gestao-acessos.component.html',
  styleUrl: './modal-gestao-acessos.component.css',
  standalone: false
})
export class ModalGestaoAcessosComponent {
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public permissaoService: PermissaoService,
    private authService: AuthService,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private saldoService: SaldoService
  ) {  }

  EnumPermissao = EnumPermissao;
  @Input() usuario?: Usuario = undefined;
  @Input() mostrarModal: boolean = false;
  @Input() todasPermissoes: OptionPermissao[] = [];  
  @Output() fecharModal = new EventEmitter<void>();
  @Output() permissoesSalvas = new EventEmitter<void>();
  
  requestSalvarPermissoes: RequestSalvarPermissoes = {
    idUsuario: this.usuario?.idUsuario ?? 0,
    idCliente: this.usuario?.idCliente ?? 0,
    permissoes: [],
    limiteContatos: undefined
  };

  permissoesUsuario: number[] = [];
  carregandoPermissoes: boolean = false;
  salvandoPermissoes: boolean = false;
  usuarioLogadoEhMaster: boolean = false;
  usuarioEditadoEhMaster: boolean = false;
  private _limiteContatos: number = 0;

  get limiteContatosExibicao(): string {
    return this._limiteContatos === 0 ? '' : this._limiteContatos.toString();
  }

  set limiteContatosExibicao(value: string) {
    const apenasNumeros = value.replace(/\D/g, '');
    this._limiteContatos = apenasNumeros ? parseInt(apenasNumeros) : 0;
    this.requestSalvarPermissoes.limiteContatos = this._limiteContatos;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.mostrarModal && this.usuario) {
        this.usuarioLogadoEhMaster = this.authService.getIsMaster();
        this.usuarioEditadoEhMaster = this.usuario.master;
        
        this.requestSalvarPermissoes.idUsuario = this.usuario.idUsuario;
        this.requestSalvarPermissoes.idCliente = this.usuario.idCliente; 
        
        this.carregarPermissoesUsuario();                  
      }
  }

  async carregarPermissoesUsuario(): Promise<void> {
    if (!this.usuario?.idUsuario || !this.usuario?.idCliente) return;

    try {
      this.carregandoPermissoes = true;
      const response = await this.permissaoService.buscarPermissoesUsuario(this.usuario.idUsuario, this.usuario.idCliente);
      this.permissoesUsuario = response.permissoes;
      this.limiteContatosExibicao = response.limiteContatos.toString();
    } catch (error) {
      console.error('Erro ao carregar permissões:', error);
    } finally {
      this.carregandoPermissoes = false;
    }
  }

  temPermissao(permissaoId: number): boolean {
    return this.permissoesUsuario.includes(permissaoId);
  }

  async salvarPermissoesUsuario(): Promise<void> {
    if(!this.validarFormulario()) 
      return;

    try {
      this.salvandoPermissoes = true;
      const checkboxes = document.querySelectorAll('.opcoes-container input[type="checkbox"]');
      this.requestSalvarPermissoes.permissoes = Array.from(checkboxes)
        .map(checkbox => ({
          idPermissao: parseInt((checkbox as HTMLInputElement).value),
          TemAcesso: (checkbox as HTMLInputElement).checked
        })) as PermissaoUsuario[];
  
      try{
        this.requestSalvarPermissoes.limiteContatos = !this.requestSalvarPermissoes.limiteContatos ? 0 : this.requestSalvarPermissoes.limiteContatos;
        this.requestSalvarPermissoes.permissoes = this.usuarioEditadoEhMaster ? [] : this.requestSalvarPermissoes.permissoes;
        await this.usuarioService.salvarPermissoesUsuario(this.requestSalvarPermissoes);
        this.toastr.success("Permissões salvas com sucesso");
        
        const novoSaldo = await this.saldoService.obterSaldo();
        this.saldoService.atualizarSaldo(novoSaldo);

        this.fechar();
        this.permissoesSalvas.emit(); 
      } catch (error) {
        console.error('Erro ao salvar permissões:', error);
      } finally {
        this.salvandoPermissoes = false;
      }
      
    } catch (error) {
      console.error('Erro ao obter permissões:', error);
    } finally {
      this.salvandoPermissoes = false;
    }
  } 

  validarFormulario(): boolean {
    if (!this.usuario?.idUsuario || !this.usuario?.idCliente) {
      this.toastr.error("Usuário não encontrado");
      return false;
    }

    if(!this.permissaoService.hasPermission(EnumPermissao.CriarNovosUsuarios)) {
      this.toastr.error("Usuário não tem permissão para criar novos usuários");
      return false;
    }

    if(this.requestSalvarPermissoes.limiteContatos && (this.requestSalvarPermissoes.limiteContatos < 0 || this.requestSalvarPermissoes.limiteContatos > 2147483647)) {
      this.toastr.error("Limite de contatos deve ser um número positivo e menor que 2.147.483.647");
      return false;
    }

    return true;
  }

  fechar(): void {
    this.permissoesUsuario = [];
    this.usuario = undefined;
    this.limiteContatosExibicao = '';
    this.fecharModal.emit();
  } 

  onChangeLimiteContatos(event: any): void {
    const valor = event.target.value;
    const apenasNumeros = valor.replace(/\D/g, '');
    this.requestSalvarPermissoes.limiteContatos = apenasNumeros ? parseInt(apenasNumeros) : 0;
    event.target.value = apenasNumeros || '';
  }
}
